import React, { createContext, useContext, useState, useCallback } from 'react';

interface PageHeaderContextType {
  leftContent: React.ReactNode;
  setLeftContent: (content: React.ReactNode) => void;
  clearHeader: () => void;
}

const PageHeaderContext = createContext<PageHeaderContextType | null>(null);

export function PageHeaderProvider({ children }: { children: React.ReactNode }) {
  const [leftContent, setLeftContent] = useState<React.ReactNode>(null);

  const clearHeader = useCallback(() => {
    setLeftContent(null);
  }, []);

  return (
    <PageHeaderContext.Provider value={{ leftContent, setLeftContent, clearHeader }}>
      {children}
    </PageHeaderContext.Provider>
  );
}

export function usePageHeader() {
  const context = useContext(PageHeaderContext);
  
  if (!context) {
    throw new Error('usePageHeader must be used within PageHeaderProvider');
  }
  
  return context;
}

export default PageHeaderContext;